import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { TextFieldWrapper } from 'src/components';
import { Form } from 'src/components/tracking';
import { PageLink } from 'src/components/links';
import { Button, Page, Panel, Stack } from 'src/components/matchbox';
import { required, email } from 'src/helpers/validation';
import { inviteUser } from 'src/actions/users';
import { showAlert } from 'src/actions/globalAlert';
import { trimWhitespaces } from 'src/helpers/string';
import { FORMS, ROLES } from 'src/constants';
import { isAccountUiOptionSet } from 'src/helpers/conditions/account';
import { RUDDERSTACK_EVENTS } from 'src/helpers/rudderstack';
import RoleRadioGroup from './components/RoleRadioGroup';
import SubaccountAssignment from './components/SubaccountAssignment';
import { hasSubaccounts } from 'src/selectors/subaccounts';
import track from 'src/helpers/track';

const breadcrumbAction = {
  content: 'Users',
  Component: PageLink,
  to: '/account/users'
};

export class CreatePage extends Component {
  handleSubmit = (values) => {
    const { inviteUser, showAlert, history } = this.props;
    const { email, access, useSubaccount, subaccount } = values;

    const access_level = useSubaccount
      ? access === ROLES.DEVELOPER
        ? ROLES.SUBACCOUNT_DEVELOPER
        : ROLES.SUBACCOUNT_REPORTING
      : access;

    return inviteUser(email, access_level, subaccount).then(() => {
      showAlert({
        type: 'success',
        message: `Invitation sent to ${email}`
      });
      history.push('/account/users');
      track(RUDDERSTACK_EVENTS.INVITE_SENT, {
        invitee_email: email,
        invitee_role: access_level
      });
    });
  };

  render() {
    const {
      submitting,
      pristine,
      handleSubmit,
      isSubaccountReportingLive,
      selectedRole,
      useSubaccountChecked
    } = this.props;

    return (
      <Page title="Invite User" breadcrumbAction={breadcrumbAction}>
        <Panel.LEGACY>
          <Form onSubmit={handleSubmit(this.handleSubmit)} id="users-create-form">
            <Panel.LEGACY.Section>
              <Stack>
                <Field
                  name="email"
                  validate={[required, email]}
                  normalize={trimWhitespaces}
                  label="Email address"
                  component={TextFieldWrapper}
                  data-sensitive={true}
                  helpText="An invitation will be sent to the email address you supply"
                />
                <Field name="access" component={RoleRadioGroup} data-track={true} />
                {isSubaccountReportingLive && hasSubaccounts && (
                  <SubaccountAssignment
                    selectedRole={selectedRole}
                    useSubaccountChecked={useSubaccountChecked}
                  />
                )}
              </Stack>
            </Panel.LEGACY.Section>

            <Panel.LEGACY.Section>
              <Button variant="primary" submit disabled={submitting || pristine}>
                {submitting ? 'Loading' : 'Add User'}
              </Button>
            </Panel.LEGACY.Section>
          </Form>
        </Panel.LEGACY>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  initialValues: {
    access: ROLES.ADMIN // Sadly redux-form does not reflect a select's initial value
  },
  isSubaccountReportingLive: isAccountUiOptionSet('subaccount_reporting')(state),
  selectedRole: formValueSelector(FORMS.INVITE_USER)(state, 'access'),
  hasSubaccounts: hasSubaccounts(state),
  useSubaccountChecked: formValueSelector(FORMS.INVITE_USER)(state, 'useSubaccount')
});

const mapDispatchToProps = { inviteUser, showAlert };

const ReduxCreatePage = reduxForm({ form: FORMS.INVITE_USER })(CreatePage);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReduxCreatePage));
